module.exports = __webpack_public_path__ + "img/varios-passaros-origami-alinhados.jpg";